"use client";

import { c as _c } from "react/compiler-runtime";
import { ExtendedDrop, getDropPreviewImageUrl } from "@/helpers/waves/drop.helpers";
import { useEffect, useMemo, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";
import WaveDropPartContentMedias from "../drops/WaveDropPartContentMedias";
import WaveDropPartContentMarkdown from "../drops/WaveDropPartContentMarkdown";
import { ImageScale, getScaledImageUri } from "@/helpers/image.helpers";
interface WaveSmallLeaderboardItemContentProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: () => void;
}
export const WaveSmallLeaderboardItemContent: React.FC<WaveSmallLeaderboardItemContentProps> = t0 => {
  const $ = _c(38);
  const {
    drop,
    onDropClick
  } = t0;
  const contentRef = useRef(null);
  const [showGradient, setShowGradient] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (contentRef.current) {
        setShowGradient(contentRef.current.scrollHeight > 208);
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== drop) {
    t2 = [drop];
    $[1] = drop;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== drop.metadata) {
    t3 = getDropPreviewImageUrl(drop.metadata);
    $[3] = drop.metadata;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const previewImageUrl = t3;
  const isStorm = drop.parts.length > 1;
  const haveMetadata = !!drop.metadata.length;
  let t4;
  if ($[5] !== drop.parts) {
    t4 = drop.parts.filter(_temp);
    $[5] = drop.parts;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const haveMedia = !!t4.length;
  let t5;
  if ($[7] !== drop.parts[0] || $[8] !== previewImageUrl) {
    t5 = previewImageUrl ? <div className="tw-w-full tw-flex tw-justify-center"><img src={getScaledImageUri(previewImageUrl, ImageScale.AUTOx450)} alt="Preview" className="tw-max-w-full tw-max-h-48 tw-object-contain tw-rounded-lg" /></div> : !!drop.parts[0]?.media.length && <WaveDropPartContentMedias activePart={drop.parts[0]} disableMediaInteraction={true} imageScale={ImageScale.AUTOx450} />;
    $[7] = drop.parts[0];
    $[8] = previewImageUrl;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== drop.mentioned_users || $[11] !== drop.parts[0] || $[12] !== drop.referenced_nfts || $[13] !== drop.wave) {
    t6 = <WaveDropPartContentMarkdown mentionedUsers={drop.mentioned_users} referencedNfts={drop.referenced_nfts} part={drop.parts[0]} wave={drop.wave} onQuoteClick={_temp2} />;
    $[10] = drop.mentioned_users;
    $[11] = drop.parts[0];
    $[12] = drop.referenced_nfts;
    $[13] = drop.wave;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== showGradient) {
    t7 = showGradient && <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-z-[1] tw-h-12 tw-bg-gradient-to-t tw-from-iron-900 tw-via-iron-900 tw-to-transparent" />;
    $[15] = showGradient;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== onDropClick || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <div ref={contentRef} onClick={onDropClick} className="tw-relative tw-max-h-52 tw-cursor-pointer tw-space-y-3 tw-overflow-hidden">{t5}{t6}{t7}</div>;
    $[17] = onDropClick;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== drop.id || $[23] !== isStorm) {
    t9 = isStorm && <><svg className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-text-iron-400" viewBox="0 0 24 24" fill="none" aria-hidden="true" data-tooltip-id={`wave-storm-${drop.id}`}><path d="M3.75 13.5L14.25 2.25L12 10.5H20.25L9.75 21.75L12 13.5H3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><Tooltip id={`wave-storm-${drop.id}`} place="top" style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px",
        zIndex: 10
      }}><span className="tw-text-xs">Storm</span></Tooltip></>;
    $[22] = drop.id;
    $[23] = isStorm;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== drop.id || $[26] !== haveMetadata) {
    t10 = !!haveMetadata && <><svg className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-text-iron-400" viewBox="0 0 24 24" aria-hidden="true" fill="none" data-tooltip-id={`wave-metadata-${drop.id}`}><path d="M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><Tooltip id={`wave-metadata-${drop.id}`} place="top" style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px",
        zIndex: 10
      }}><span className="tw-text-xs">Metadata</span></Tooltip></>;
    $[25] = drop.id;
    $[26] = haveMetadata;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== drop.id || $[29] !== haveMedia) {
    t11 = !!haveMedia && <><svg className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0 tw-text-iron-400" viewBox="0 0 24 24" aria-hidden="true" fill="none" data-tooltip-id={`wave-media-${drop.id}`}><path d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><Tooltip id={`wave-media-${drop.id}`} place="top" style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px",
        zIndex: 10
      }}><span className="tw-text-xs">Media</span></Tooltip></>;
    $[28] = drop.id;
    $[29] = haveMedia;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t10 || $[32] !== t11 || $[33] !== t9) {
    t12 = <div className="tw-mb-3 tw-mt-3 tw-flex tw-items-center tw-gap-x-2">{t9}{t10}{t11}</div>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t9;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12 || $[36] !== t8) {
    t13 = <div>{t8}{t12}</div>;
    $[35] = t12;
    $[36] = t8;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
};
function _temp(part) {
  return !!part.media.length;
}
function _temp2() {}